export default __webpack_public_path__ + "static/media/ic_stats.a4f481e2.svg";